import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, BookOpen, Clock, BarChart3, History, Layers, AlertCircle, TrendingUp, Eraser, Hammer, RefreshCw, CreditCard, Landmark, Building2, Building, BadgeDollarSign, UserCheck, ShieldAlert, Star, Rocket } from 'lucide-react';
export function ModulesSection() {
  const modules = [{
    num: '01',
    title: '¿Por Qué el Crédito lo Cambia Todo?',
    icon: <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-130" />
  }, {
    num: '02',
    title: 'Fundamentos del Crédito en USA',
    icon: <BookOpen className="w-6 h-6 text-brand-gold" data-id="element-131" />
  }, {
    num: '03',
    title: 'Historial de Pagos — El Factor Más Importante (35%)',
    icon: <Clock className="w-6 h-6 text-brand-gold" data-id="element-132" />
  }, {
    num: '04',
    title: 'Utilización del Crédito — El Factor Más Controlable (30%)',
    icon: <BarChart3 className="w-6 h-6 text-brand-gold" data-id="element-133" />
  }, {
    num: '05',
    title: 'Antigüedad del Historial — El Factor de la Paciencia (15%)',
    icon: <History className="w-6 h-6 text-brand-gold" data-id="element-134" />
  }, {
    num: '06',
    title: 'Mix de Crédito — La Diversidad que Suma (10%)',
    icon: <Layers className="w-6 h-6 text-brand-gold" data-id="element-135" />
  }, {
    num: '07',
    title: 'Nuevo Crédito — El Factor del Riesgo Reciente (10%)',
    icon: <AlertCircle className="w-6 h-6 text-brand-gold" data-id="element-136" />
  }, {
    num: '08',
    title: 'Estrategia para Mejorar tu Crédito',
    icon: <TrendingUp className="w-6 h-6 text-brand-gold" data-id="element-137" />
  }, {
    num: '09',
    title: 'Limpieza del Historial Crediticio',
    icon: <Eraser className="w-6 h-6 text-brand-gold" data-id="element-138" />
  }, {
    num: '10',
    title: 'Construcción de Crédito desde Cero',
    icon: <Hammer className="w-6 h-6 text-brand-gold" data-id="element-139" />
  }, {
    num: '11',
    title: 'Mantenimiento y Sistema Automático',
    icon: <RefreshCw className="w-6 h-6 text-brand-gold" data-id="element-140" />
  }, {
    num: '12',
    title: 'Comparación Inteligente de Tarjetas de Crédito en USA',
    icon: <CreditCard className="w-6 h-6 text-brand-gold" data-id="element-141" />
  }, {
    num: '13',
    title: 'Los 5 Bancos que Debes Conocer',
    icon: <Landmark className="w-6 h-6 text-brand-gold" data-id="element-142" />
  }, {
    num: '14',
    title: 'Análisis por Banco — Capital One & Discover',
    icon: <Building2 className="w-6 h-6 text-brand-gold" data-id="element-143" />
  }, {
    num: '15',
    title: 'Análisis por Banco — Chase & American Express',
    icon: <Building className="w-6 h-6 text-brand-gold" data-id="element-144" />
  }, {
    num: '16',
    title: 'Análisis por Banco — Citi',
    icon: <BadgeDollarSign className="w-6 h-6 text-brand-gold" data-id="element-145" />
  }, {
    num: '17',
    title: 'Elige Según tu Situación',
    icon: <UserCheck className="w-6 h-6 text-brand-gold" data-id="element-146" />
  }, {
    num: '18',
    title: 'Errores que Debes Evitar',
    icon: <ShieldAlert className="w-6 h-6 text-brand-gold" data-id="element-147" />
  }, {
    num: '19',
    title: 'Consejo Pro — La Tarjeta que Mejor Funciona para Ti',
    icon: <Star className="w-6 h-6 text-brand-gold" data-id="element-148" />
  }, {
    num: '20',
    title: 'Tu Crédito es tu Activo — Empieza Hoy',
    icon: <Rocket className="w-6 h-6 text-brand-gold" data-id="element-149" />
  }];
  return <section className="py-24 bg-brand-gray" data-id="element-150">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-151">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-152">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-153">
            ¿Qué incluye el sistema?
          </h2>
          <p className="text-gray-600 text-lg mb-4" data-id="element-154">
            20 módulos completos paso a paso
          </p>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-155"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-156">
          {modules.map((mod, index) => <motion.div key={index} className="bg-brand-green rounded-xl p-5 shadow-premium hover:shadow-xl transition-shadow relative overflow-hidden group" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: Math.min(index * 0.05, 0.5)
        }} data-id="element-157">
              <div className="absolute top-0 right-0 w-16 h-16 bg-brand-gold/10 rounded-bl-[60px] -z-0 transition-transform group-hover:scale-110" data-id="element-158"></div>

              <div className="relative z-10" data-id="element-159">
                <div className="flex items-center gap-3 mb-3" data-id="element-160">
                  <div className="w-10 h-10 bg-brand-gold/20 rounded-lg flex items-center justify-center shrink-0" data-id="element-161">
                    {mod.icon}
                  </div>
                  <span className="text-2xl font-serif font-bold text-brand-gold/50" data-id="element-162">
                    {mod.num}
                  </span>
                </div>

                <h3 className="text-sm font-bold leading-snug" data-id="element-163">
                  <span className="text-brand-gold" data-id="element-164">{mod.title}</span>
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}